<script lang="ts" setup>
import { Head } from "@inertiajs/vue3";
import HeadingComponent from "../../Components/HeadingComponent.vue";
import EventPublicWrapper from "../EventPublic/EventPublicWrapper.vue";
import EventItineraryFrontend from "@/Pages/EventPublic/Components/EventItineraryFrontend.vue";
import Button from "@/Components/Button.vue";
import { PencilIcon } from "@heroicons/vue/20/solid";
import { DateTime } from "luxon";

interface Event {
    name: string;
    timezone: string;
    type: string;
}

interface Props {
    event: Event;
    canRegisterForEvent: boolean;
}

const props = withDefaults(defineProps<Props>(), {});
</script>

<template>
    <EventPublicWrapper>
        <Head>
            <title>
                Event itinerary:
                {{ $page.props.event.name }}
            </title>
            <meta
                name="description"
                head-key="description"
                :content="`Event itinerary: ${$page.props.meta_event_name}`"
            />
            <meta
                property="og:title"
                head-key="og:title"
                :content="`Event itinerary: ${$page.props.meta_event_name}`"
            />
            <meta
                property="og:description"
                :content="`Event itinerary: ${$page.props.meta_event_name}`"
            />
        </Head>
        <div class="w-full space-y-4 md:w-auto md:max-w-7xl">
            <HeadingComponent class="rounded-lg bg-white p-4 shadow-lg sm:px-6">
                <template #name>Itinerary</template>
                <template #description>
                    <div>Classes & sections</div>
                    <div v-if="$page.props.event.start_at">
                        Event starts at:
                        {{
                            DateTime.fromISO($page.props.event.start_at)
                                .setZone($page.props.event.timezone)
                                .toLocaleString(DateTime.DATETIME_SHORT)
                        }}
                    </div>
                </template>
            </HeadingComponent>
            <HeadingComponent
                v-if="$page.props.can.view_sensitive_event"
                class="rounded-lg bg-orange-50 p-4 shadow-lg sm:px-6"
            >
                <template #name>Event administrator tools</template>
                <template #description>
                    <div class="space-x-4 pt-4">
                        <Button
                            :href="
                                route('event.edit.itinerary', {
                                    hashid: $page.props.event.hashid,
                                    seo_slug: $page.props.event.seo_slug,
                                })
                            "
                            class="h-6"
                            variant="outline"
                            ><PencilIcon
                                class="-ml-0.5 mr-1.5 size-4"
                                aria-hidden="true"
                            />
                            Edit itinerary</Button
                        >
                    </div>
                </template>
            </HeadingComponent>
            <div class="flex flex-col">
                <EventItineraryFrontend :event="event"></EventItineraryFrontend>
            </div>
        </div>
    </EventPublicWrapper>
</template>
